import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import {
  isCommunityAdmin,
  isCommunityModerator,
} from "@circle-react/helpers/communityMemberHelpers";

export const useCanUploadMedia = () => {
  const { currentCommunityMember, currentCommunitySettings } =
    usePunditUserContext();

  const isAdminFlagEnabled = Boolean(
    currentCommunitySettings?.member_media_uploads_enabled,
  );
  const isAdminOrModerator =
    isCommunityAdmin(currentCommunityMember) ||
    isCommunityModerator(currentCommunityMember);

  return isAdminOrModerator || isAdminFlagEnabled;
};
